export default __webpack_public_path__ + "static/media/gym.6fda9b57.jpg";